import { render, staticRenderFns } from "./ProfessionalWorkingHours.vue?vue&type=template&id=991fda22"
import script from "./ProfessionalWorkingHours.vue?vue&type=script&lang=ts"
export * from "./ProfessionalWorkingHours.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports